// 今日销售数据模块
const state = {
  // 今日/周/月码洋总览及会员信息（从大屏数据派生）
  todaySales: {
    period: 'today',
    totalAmount: 0,
    amounts: { today: 0, week: 0, month: 0 },
    members: [],
    // 会员数据按周期分组
    membersByPeriod: {
      today: { new: 0, active: 0, total: 0 },
      week: { new: 0, active: 0, total: 0 },
      month: { new: 0, active: 0, total: 0 }
    },
    growth: 0
  }
}

const mutations = {
  // 设置今日码洋数据
  SET_TODAY_SALES(state, data) {
    state.todaySales = data
  },
  // 重置今日销售数据
  RESET_TODAY_SALES(state) {
    state.todaySales = {
      period: 'today',
      totalAmount: 0,
      amounts: { today: 0, week: 0, month: 0 },
      members: [],
      // 会员数据按周期分组
      membersByPeriod: {
        today: { new: 0, active: 0, total: 0 },
        week: { new: 0, active: 0, total: 0 },
        month: { new: 0, active: 0, total: 0 }
      },
      growth: 0
    }
  }
}

const actions = {
  // 获取今日/周/月码洋与会员信息（支持静默刷新，从 screenData 派生）
  async fetchTodaySales({ commit, rootState }, period = null) {
    try {
      // 如果没有传入period参数，使用当前状态的period（静默刷新模式）
      const currentPeriod = period || state.todaySales.period || 'today'
      
      const big = rootState.screen.screenData || {}
      const toNum = v => {
        const n = Number(v)
        return isNaN(n) ? 0 : n
      }
      const amounts = {
        today: toNum(big.today_mayang),
        week: toNum(big.week_mayang),
        month: toNum(big.month_mayang),
      }
      const displayAmount = amounts[currentPeriod]
      const members = Array.isArray(big.huiyuan)
        ? big.huiyuan.map(it => ({ type: it?.type || '', sl: toNum(it?.sl) }))
        : []
      
      // 解析会员数据，按周期分组
      const membersByPeriod = {
        today: { new: 0, active: 0, total: 0 },
        week: { new: 0, active: 0, total: 0 },
        month: { new: 0, active: 0, total: 0 }
      }
      
      members.forEach(member => {
        const type = member.type || ''
        const value = member.sl || 0
        
        // 处理总会员数
        if (type === '总会员数') {
          membersByPeriod.today.total = value
          membersByPeriod.week.total = value
          membersByPeriod.month.total = value
        }
        
        // 处理今日数据
        if (type === '新增会员数-今日') {
          membersByPeriod.today.new = value
        } else if (type === '新增会员数' && membersByPeriod.today.new === 0) {
          membersByPeriod.today.new = value
        }
        
        if (type === '活跃会员数-今日') {
          membersByPeriod.today.active = value
        } else if (type === '活跃会员数' && membersByPeriod.today.active === 0) {
          membersByPeriod.today.active = value
        }
        
        // 处理本周数据
        if (type === '新增会员数-本周') {
          membersByPeriod.week.new = value
        }
        if (type === '活跃会员数-本周') {
          membersByPeriod.week.active = value
        }
        
        // 处理本月数据
        if (type === '新增会员数-本月') {
          membersByPeriod.month.new = value
        }
        if (type === '活跃会员数-本月') {
          membersByPeriod.month.active = value
        }
      })
      
      commit('SET_TODAY_SALES', {
        period: currentPeriod,
        totalAmount: displayAmount,
        amounts,
        members,
        membersByPeriod,
        growth: 0
      })
    } catch (error) {
      console.error('派生今日/周/月码洋数据失败:', error)
    }
  }
}

const getters = {
  todaySales: state => state.todaySales
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
